import { render } from "./WpeNote.vue?vue&type=template&id=3722e9d5"
import script from "./WpeNote.vue?vue&type=script&lang=js"
export * from "./WpeNote.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/controls/WpeNote.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3722e9d5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3722e9d5', __exports__)) {
    api.reload('3722e9d5', __exports__)
  }
  
  module.hot.accept("./WpeNote.vue?vue&type=template&id=3722e9d5", () => {
    api.rerender('3722e9d5', render)
  })

}


export default __exports__